module.exports = __webpack_public_path__ + "img/down.3f17465f.svg";